<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <core-card [actions]="[]">
      <div class="card-title w-100">
        <div [ngClass.xl]="'float-left row pl-1'" [ngClass.sm]="'mb-075'" [ngClass.md]="'mb-1'">
          <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="searchKeyword" (ngModelChange)="searchAbsences(); changeQueryParams()" />
        </div>
        <div [ngClass.xl]="'float-left row pl-1 ml-1'">
          <select [(ngModel)]="searchStatus" class="form-control" (ngModelChange)="searchAbsences(); changeQueryParams()">
            <option value="10" selected>{{ "ALL_FEMALE_PLURAL" | translate }}</option>
            <option value="0">{{ "PENDING" | translate }}</option>
            <option value="1">{{ "APPROVED_FEMALE_PLURAL" | translate }}</option>
            <option value="2">{{ "NOT_APPROVED_PLURAL" | translate }}</option>
          </select>
        </div>
        <!-- mese-->
        <div [ngClass.xl]="'float-left pl-1 ml-1'" [ngClass.sm]="'mt-1'" [ngClass.md]="'my-1'">
          <select [(ngModel)]="selectedMonth" (ngModelChange)="loadAbsence(); changeQueryParams()" id="monthYear" class="form-control pr-3 text-capitalize">
            <option selected disabled value="all">{{ "MONTH" | translate }}</option>
            <option *ngFor="let month of availableMonths" [value]="month" [label]="formatLabel(month)">{{ month }}</option>
            <option value="0">{{ "ALL" | translate }}</option>
          </select>
        </div>
        <!--anno-->
        <div [ngClass.xl]="'float-left ml-1'" [ngClass.sm]="'mt-1'" [ngClass.md]="'mb-1'" *ngIf="availableYears.length > 1">
          <select id="years" [(ngModel)]="selectedYear" (ngModelChange)="loadAbsence(); changeQueryParams()" class="form-control pr-3">
            <option selected disabled value="all">{{ "YEAR" | translate }}</option>
            <option *ngFor="let year of availableYears" [value]="year">{{ year }}</option>
          </select>
        </div>
        <div class="float-right">
          <div [ngClass.xl]="'w-fit d-inline-block'" [ngClass.sm]="'d-none'" [ngClass.md]="'d-none'">
            <label class="d-flex align-items-center"
              >{{ "SHOW" | translate }}
              <select class="form-control ml-075 pr-3" (change)="updateTableLimit($event)">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </label>
          </div>
        </div>
        <div class="clearboth"></div>
      </div>
      <!-- desktop-->
      <div class="card-body px-0 pb-0">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="30"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [scrollbarH]="true"
          [rowHeight]="_utilService.isDesktop ? 70 : 200"
          [limit]="tableLimit"
          [footerHeight]="50"
          [rows]="filteredAbsences"
        >
          <ngx-datatable-column name="{{ 'FIRSTNAME' | translate }}" prop="employee.complete_name" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.employee.complete_name }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'TYPE_ABSENCE' | translate }}" prop="type.name" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span class="line-height-1">{{ row.type.name }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'FROM' | translate }}" prop="from" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ getFormat(row.from, row) }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'TO' | translate }}" prop="to" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ getFormat(row.to, row) }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'STATE' | translate }}" prop="status" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span class="badge badge-success" *ngIf="row.status === 1">{{ row.enabled_label }}</span>
              <span class="badge badge-warning" *ngIf="row.status === 0">{{ row.enabled_label }}</span>
              <span class="badge badge-danger" *ngIf="row.status === 2">{{ row.enabled_label }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'ACTIONS' | translate }}" [sortable]="false" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <button class="btn btn-outline-secondary ml-1 btn-sm" (click)="openModal(viewAbsence, row.id)">{{ "VIEW" | translate }}</button>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <!-- mobile - tablet-->
          <ngx-datatable-column name="{{ 'FIRSTNAME' | translate }}" prop="employee.complete_name" width="100" [sortable]="true" *ngIf="!_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile">
                <div [class]="'col-' + (row.status == 1 || row.status == 0 ? 9 : 8)">
                  <span>{{ row.employee.complete_name }}</span>
                </div>
                <div [class]="'col-' + (row.status == 1 || row.status == 0 ? 3 : 4)">
                  <span class="badge badge-success" *ngIf="row.status === 1">{{ row.enabled_label }}</span>
                  <span class="badge badge-warning" *ngIf="row.status === 0">{{ row.enabled_label }}</span>
                  <span class="badge badge-danger" *ngIf="row.status === 2">{{ row.enabled_label }}</span>
                </div>
                <div class="col-12 my-1">
                  <span>{{ row.type.name }}</span>
                </div>
                <div class="col-12">
                  <span
                    >{{ "FROM" | translate }}: {{ getFormat(row.from, row) }} - {{ "TO" | translate }}: <span>{{ getFormat(row.to, row) }}</span></span
                  >
                </div>
                <div class="col-12 mt-1">
                  <button class="btn btn-outline-secondary" (click)="openModal(viewAbsence, row.id)">{{ "VIEW" | translate }}</button>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </core-card>
  </div>
</div>

<!-- Modal -->
<ng-template #viewAbsence let-modal>
  <form>
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ currentAbsence.type.category | titlecase }}</h3>
      <div class="row">
        <div class="col-6">
          <small class="text-muted mb-0 pb-0">{{ "FIRSTNAME" | translate }}:</small>
          <p>{{ currentAbsence.employee.complete_name }}</p>
        </div>
        <div class="col-6">
          <small class="text-muted mb-0 pb-0">{{ "TYPE_ABSENCE" | translate }}:</small>
          <p>{{ currentAbsence.type.name }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <small *ngIf="currentAbsence.type.category === 'permesso'" class="text-muted mb-0 pb-0">{{ "HOUR_FROM" | translate }}:</small>
          <small *ngIf="currentAbsence.type.category !== 'permesso'" class="text-muted mb-0 pb-0">{{ "FROM" | translate }}:</small>

          <p>{{ getFormat(currentAbsence.from, currentAbsence) }}</p>
        </div>
        <div class="col-6">
          <small *ngIf="currentAbsence.type.category === 'permesso'" class="text-muted mb-0 pb-0">{{ "HOUR_TO" | translate }}:</small>
          <small *ngIf="currentAbsence.type.category !== 'permesso'" class="text-muted mb-0 pb-0">{{ "TO" | translate }}:</small>
          <p>{{ getFormat(currentAbsence.to, currentAbsence) }}</p>
        </div>
      </div>
      <div *ngIf="currentAbsence.note" class="row">
        <div class="col-6">
          <small class="text-muted mb-0 pb-0">{{ "NOTE" | translate }}:</small>
          <p>{{ currentAbsence.note }}</p>
        </div>
      </div>
      <div *ngIf="currentAbsence.file" class="row">
        <div class="col-6">
          <small class="text-muted mb-0 pb-0">{{ "FILE" | translate }}:</small>
          <a class="d-block text-primary" (click)="loadAttachment(currentAbsence.file)">{{ "VIEW" | translate }} {{ "FILE" | translate }}</a>
        </div>
      </div>
      <div *ngIf="currentAbsence.status_note" class="row">
        <div class="col-6">
          <small class="text-muted mb-0 pb-0">{{ "MOTIVATION" | translate }}:</small>
          <p>{{ currentAbsence.status_note }}</p>
        </div>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center" *ngIf="currentAbsence.status < 3 && _authenticationService.hasCapability('edit_others_absences') && currentAbsence.employee.hash !== me.hash">
      <button
        *ngIf="currentAbsence.employee.hash !== me.hash && (currentAbsence.status === 0 || currentAbsence.status === 1)"
        (click)="toggleEnabled(currentAbsence, 'reject'); modal.close()"
        type="button"
        class="btn btn-outline-danger w-150"
        rippleEffect
      >
        {{ "REJECT" | translate }}
      </button>
      <button
        *ngIf="currentAbsence.employee.hash !== me.hash && currentAbsence.status === 0"
        (click)="toggleEnabled(currentAbsence, 'approve'); modal.close()"
        type="button"
        class="btn btn-outline-success w-150"
        rippleEffect
      >
        {{ "APPROVE" | translate }}
      </button>
    </div>
  </form>
</ng-template>
<!-- / Modal -->

<!-- note Rejected Absence Modal -->
<ng-template #noteRejectModal let-modal>
  <div>
    <div class="modal-header">
      <div></div>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "INSERT_MOTIVATION_NOTE" | translate }}</h3>
      <div class="form-group mb-1">
        <label for="rejectedNote2">{{ "MOTIVATION" | translate }}<sup class="text-danger">*</sup></label>
        <textarea [(ngModel)]="rejectedNote" class="form-control" name="rejectedNote" id="rejectedNote2" cols="45" rows="3"></textarea>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button class="btn btn-outline-primary" (click)="modalClose()">{{ "BACK" | translate }}</button>
      <button [disabled]="rejectedNote.length < 5" (click)="rejectAbsence(currentAbsence)" class="btn btn-primary w-150" rippleEffect>
        {{ "SEND" | translate }}
      </button>
    </div>
  </div>
</ng-template>
<!-- / note Rejected Absence Modal -->
